/*
 * AUTOGENERATED - DON'T EDIT
 * Your edits in this file will be overwritten in the next build!
 * Modify the docusaurus.config.js file at your site's root instead.
 */
export default {
  "onBrokenMarkdownLinks": "warn",
  "title": "EUDI Wallet and European Business Wallet Developer Docs and APIs | iGrant.io",
  "tagline": "Build on the European Digital Identity Wallet framework. Full support for OpenID4VC, SD-JWT, and ISO 18013-5 mdoc.",
  "url": "https://docs.igrant.io",
  "baseUrl": "/",
  "trailingSlash": true,
  "onBrokenLinks": "throw",
  "favicon": "img/favicons/favicon.ico",
  "headTags": [
    {
      "tagName": "link",
      "attributes": {
        "rel": "preload",
        "as": "image",
        "type": "image/webp",
        "href": "/img/homepage-hero/hero-pillars-light.webp"
      }
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "preconnect",
        "href": "https://fonts.googleapis.com"
      }
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "preconnect",
        "href": "https://fonts.gstatic.com",
        "crossorigin": "anonymous"
      }
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "stylesheet",
        "href": "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
      }
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "icon",
        "type": "image/x-icon",
        "href": "/img/favicons/favicon.ico"
      }
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "icon",
        "type": "image/png",
        "sizes": "16x16",
        "href": "/img/favicons/favicon-16x16.png"
      }
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "icon",
        "type": "image/png",
        "sizes": "32x32",
        "href": "/img/favicons/favicon-32x32.png"
      }
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "apple-touch-icon",
        "href": "/img/favicons/apple-touch-icon.png"
      }
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "icon",
        "type": "image/png",
        "sizes": "192x192",
        "href": "/img/favicons/android-chrome-192x192.png"
      }
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "icon",
        "type": "image/png",
        "sizes": "512x512",
        "href": "/img/favicons/android-chrome-512x512.png"
      }
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "manifest",
        "href": "/site.webmanifest"
      }
    }
  ],
  "scripts": [
    {
      "src": "/js/embed-mode.js",
      "async": false
    }
  ],
  "organizationName": "iGrant.io",
  "projectName": "docs.igrant.io",
  "presets": [
    [
      "classic",
      {
        "docs": {
          "sidebarPath": "/usr/src/app/sidebars.js",
          "editUrl": "https://github.com/L3-iGrant/docs.igrant.io/tree/master",
          "docLayoutComponent": "@theme/DocPage",
          "docItemComponent": "@theme/ApiItem",
          "showLastUpdateAuthor": false,
          "showLastUpdateTime": true
        },
        "theme": {
          "customCss": "/usr/src/app/src/css/custom.scss"
        }
      }
    ]
  ],
  "themeConfig": {
    "structuredData": {
      "excludedRoutes": [
        "/docs/category/consent-management-admin-api/audit",
        "/docs/category/consent-management-admin-api/data-policy",
        "/docs/category/consent-management-admin-api/data-agreement",
        "/docs/category/consent-management-admin-api/data-attribute",
        "/docs/category/consent-management-admin-api/individual",
        "/docs/category/consent-management-admin-api/webhook",
        "/docs/category/consent-management-individual-api/consent-record",
        "/docs/category/consent-management-individual-api/data-agreement",
        "/docs/category/consent-management-individual-api/data-policy",
        "/docs/category/consent-management-individual-api/data-sharing",
        "/docs/category/consent-management-individual-api/identity-provider",
        "/docs/category/consent-management-individual-api/organisation",
        "/docs/category/consent-management-individual-api/verification",
        "/docs/category/openid4vc-api/issuer",
        "/docs/category/openid4vc-api/verifier",
        "/docs/category/openid4vc-api/holder",
        "/docs/category/openid4vc-api/trust-anchor",
        "/docs/category/openid4vc-api/webhook",
        "/docs/category/openid4vc-api/wallet-provider",
        "/docs/category/openid4vc-api/key-management",
        "/docs/category/extensions-api/open-id-connect-client",
        "/docs/category/extensions-api/open-id-provider-main-tenant",
        "/docs/category/extensions-api/open-id-provider-sandbox-organisation",
        "/docs/category/extensions-api/manage-extension",
        "/docs/category/drv-bund-api/authentication",
        "/docs/category/drv-bund-api/upload-attestation-data",
        "/docs/category/datamarketplace-api/base-configurations",
        "/docs/category/datamarketplace-api/data-disclosure-agreements",
        "/docs/category/datamarketplace-api/signed-agreements",
        "/docs/category/datamarketplace-api/authorisation-server",
        "/docs/category/datamarketplace-individual-api/base-configurations",
        "/docs/category/datamarketplace-individual-api/data-disclosure-agreements",
        "/docs/category/datamarketplace-individual-api/signed-agreements",
        "/docs/category/datamarketplace-individual-api/authorisation-server",
        "/ssi/ssi-test",
        "/docs/category/datamarketplace-api/webhook",
        "/docs/category/datamarketplace-api/access-logs"
      ],
      "verbose": true,
      "featuredImageDimensions": {
        "width": 1200,
        "height": 627
      },
      "authors": {
        "lalc": {
          "authorId": "1",
          "url": "",
          "imageUrl": "",
          "sameAs": []
        }
      },
      "organization": {
        "sameAs": [
          "https://twitter.com/igrantio",
          "https://www.linkedin.com/company/igrantio/",
          "https://www.facebook.com/igrantio/",
          "https://www.youtube.com/channel/UCnP7dTezBirfSABcCZga4mA",
          "https://bsky.app/profile/igrantio.bsky.social"
        ],
        "contactPoint": {
          "@type": "ContactPoint",
          "email": "support@igrant.io"
        },
        "logo": {
          "@type": "ImageObject",
          "inLanguage": "en-US",
          "@id": "https://igrant.io/#logo",
          "url": "https://igrant.io/assets/images/favicons/preview.png",
          "contentUrl": "https://igrant.io/assets/images/favicons/preview.png",
          "width": 1440,
          "height": 900,
          "caption": "iGrant.io: Your data, your choice"
        },
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "Sollentuna, Sweden",
          "postalCode": "19255",
          "streetAddress": "Bössvägen 28"
        },
        "hasCredential": {
          "@type": "EducationalOccupationalCredential",
          "credentialCategory": "certification",
          "name": "ISO/IEC 27001:2022",
          "recognizedBy": {
            "@type": "Organization",
            "name": "InterCert"
          },
          "url": "https://www.iafcertsearch.org/certification/km2vH6e1i3j2Ai0WISr9krvR",
          "validFrom": "2026-07-06",
          "validUntil": "2027-07-05"
        }
      },
      "website": {
        "inLanguage": "en-US"
      },
      "webpage": {},
      "breadcrumbLabelMap": {}
    },
    "docs": {
      "sidebar": {
        "hideable": false,
        "autoCollapseCategories": false
      },
      "versionPersistence": "localStorage"
    },
    "colorMode": {
      "disableSwitch": true,
      "defaultMode": "light",
      "respectPrefersColorScheme": false
    },
    "navbar": {
      "title": "",
      "logo": {
        "href": "/",
        "alt": "iGrant.io Logo",
        "src": "img/logo.svg"
      },
      "items": [
        {
          "to": "docs/get-started/",
          "activeBasePath": "docs",
          "label": "Get Started",
          "position": "left"
        },
        {
          "to": "concepts/",
          "activeBasePath": "concepts",
          "label": "EUDI Wallet Insights",
          "position": "left"
        },
        {
          "to": "regulations/",
          "activeBasePath": "regulations",
          "label": "eIDAS & EU Regulations",
          "position": "left"
        },
        {
          "to": "/docs/developer-apis",
          "activeBasePath": "api",
          "label": "Developer APIs",
          "position": "left"
        },
        {
          "href": "https://support.igrant.io/",
          "label": "Support Desk",
          "position": "right",
          "target": "_self",
          "className": "navbar-support-link"
        }
      ],
      "hideOnScroll": false
    },
    "image": "img/iGrant_1920_1080_Black_R.png",
    "twitterImage": "img/iGrant.io_round_logo.png",
    "ogImage": "img/iGrant_1920_1080_Black_R.png",
    "ogTitle": "iGrant.io - European Digital Identity Wallet and European Business Wallet",
    "footer": {
      "style": "dark",
      "links": [
        {
          "title": "Links",
          "items": [
            {
              "label": "iGrant.io Home",
              "href": "https://igrant.io"
            },
            {
              "label": "EU Digital Identity Wallet",
              "to": "https://ec.europa.eu/digital-building-blocks/sites/display/EUDIGITALIDENTITYWALLET"
            },
            {
              "label": "EU Architecture and Reference Framework",
              "to": "https://eudi.dev/latest/architecture-and-reference-framework-main/"
            }
          ]
        },
        {
          "title": "Follow us",
          "items": [
            {
              "label": "Linkedin",
              "href": "https://www.linkedin.com/company/igrantio"
            },
            {
              "label": "Twitter",
              "href": "https://twitter.com/igrantio"
            },
            {
              "label": "Youtube",
              "href": "https://www.youtube.com/igrantio"
            },
            {
              "label": "Facebook",
              "href": "https://www.facebook.com/igrantio/"
            }
          ]
        },
        {
          "title": "GitHub Sourcecode",
          "items": [
            {
              "href": "https://github.com/L3-iGrant",
              "label": "iGrant.io"
            },
            {
              "href": "https://github.com/decentralised-dataexchange",
              "label": "Decentralised Data Exchange (Opensource)"
            }
          ]
        }
      ],
      "copyright": "<span style=\"color:#ffffff;\">Copyright © 2017-2026 iGrant Technologies AB, Sweden</span> · <a href=\"https://www.iafcertsearch.org/certification/km2vH6e1i3j2Ai0WISr9krvR\" target=\"_blank\" rel=\"noopener noreferrer\" style=\"color:#ffffff;text-decoration:none;display:inline-flex;align-items:center;gap:4px;vertical-align:middle;\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"flex-shrink:0;\"><path d=\"M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z\"/><path d=\"m9 12 2 2 4-4\"/></svg>ISO/IEC 27001:2022 Certified</a>"
    },
    "prism": {
      "theme": {
        "plain": {
          "color": "#393A34",
          "backgroundColor": "#f6f8fa"
        },
        "styles": [
          {
            "types": [
              "comment",
              "prolog",
              "doctype",
              "cdata"
            ],
            "style": {
              "color": "#999988",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "namespace"
            ],
            "style": {
              "opacity": 0.7
            }
          },
          {
            "types": [
              "string",
              "attr-value"
            ],
            "style": {
              "color": "#e3116c"
            }
          },
          {
            "types": [
              "punctuation",
              "operator"
            ],
            "style": {
              "color": "#393A34"
            }
          },
          {
            "types": [
              "entity",
              "url",
              "symbol",
              "number",
              "boolean",
              "variable",
              "constant",
              "property",
              "regex",
              "inserted"
            ],
            "style": {
              "color": "#36acaa"
            }
          },
          {
            "types": [
              "atrule",
              "keyword",
              "attr-name",
              "selector"
            ],
            "style": {
              "color": "#00a4db"
            }
          },
          {
            "types": [
              "function",
              "deleted",
              "tag"
            ],
            "style": {
              "color": "#d73a49"
            }
          },
          {
            "types": [
              "function-variable"
            ],
            "style": {
              "color": "#6f42c1"
            }
          },
          {
            "types": [
              "tag",
              "selector",
              "keyword"
            ],
            "style": {
              "color": "#00009f"
            }
          }
        ]
      },
      "darkTheme": {
        "plain": {
          "color": "#F8F8F2",
          "backgroundColor": "#282A36"
        },
        "styles": [
          {
            "types": [
              "prolog",
              "constant",
              "builtin"
            ],
            "style": {
              "color": "rgb(189, 147, 249)"
            }
          },
          {
            "types": [
              "inserted",
              "function"
            ],
            "style": {
              "color": "rgb(80, 250, 123)"
            }
          },
          {
            "types": [
              "deleted"
            ],
            "style": {
              "color": "rgb(255, 85, 85)"
            }
          },
          {
            "types": [
              "changed"
            ],
            "style": {
              "color": "rgb(255, 184, 108)"
            }
          },
          {
            "types": [
              "punctuation",
              "symbol"
            ],
            "style": {
              "color": "rgb(248, 248, 242)"
            }
          },
          {
            "types": [
              "string",
              "char",
              "tag",
              "selector"
            ],
            "style": {
              "color": "rgb(255, 121, 198)"
            }
          },
          {
            "types": [
              "keyword",
              "variable"
            ],
            "style": {
              "color": "rgb(189, 147, 249)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "comment"
            ],
            "style": {
              "color": "rgb(98, 114, 164)"
            }
          },
          {
            "types": [
              "attr-name"
            ],
            "style": {
              "color": "rgb(241, 250, 140)"
            }
          }
        ]
      },
      "additionalLanguages": [
        "ruby",
        "csharp",
        "php",
        "swift",
        "groovy",
        "kotlin",
        "bash"
      ],
      "magicComments": [
        {
          "className": "theme-code-block-highlighted-line",
          "line": "highlight-next-line",
          "block": {
            "start": "highlight-start",
            "end": "highlight-end"
          }
        }
      ]
    },
    "metadata": [
      {
        "name": "keywords",
        "content": "eIDAS, eIDAS2.0, eIDAS 2.0, EUDI Wallet, European Digital Identity Wallet, European Business Wallet, Organisation Wallet Suite, digital wallet, verifiable credentials, OpenID4VC, OpenID4VCI, OpenID4VP, OID4VC, OID4VCI, OID4VP, SD-JWT, mdoc, credential issuance, credential verification, European data governance act, ARF, Implementing Acts, iGrant.io"
      },
      {
        "property": "og:type",
        "content": "website"
      },
      {
        "property": "og:site_name",
        "content": "iGrant.io Developer Docs"
      },
      {
        "property": "og:locale",
        "content": "en"
      },
      {
        "name": "twitter:site",
        "content": "@igrantio"
      }
    ],
    "typesense": {
      "typesenseCollectionName": "docs-igrant-io",
      "typesenseServerConfig": {
        "nodes": [
          {
            "host": "typesense.igrant.io",
            "port": 443,
            "protocol": "https"
          }
        ],
        "apiKey": "PQsrQvatCldq5LBvx1DmNWgbtvlBqfTC"
      },
      "typesenseSearchParameters": {},
      "contextualSearch": true,
      "searchPagePath": "search"
    },
    "tableOfContents": {
      "minHeadingLevel": 2,
      "maxHeadingLevel": 3
    },
    "mermaid": {
      "theme": {
        "dark": "dark",
        "light": "default"
      },
      "options": {}
    }
  },
  "plugins": [
    null,
    [
      "@docusaurus/plugin-client-redirects",
      {
        "redirects": [
          {
            "from": "/docs/getting-started/",
            "to": "/docs/developer-apis/get-started/"
          },
          {
            "from": "/docs/openID4vci-issue-legal-person-identification/",
            "to": "/docs/european-business-wallet-owner-id/"
          },
          {
            "from": [
              "/docs/compliance-and-pilots/",
              "/docs/ecosystem-engagements/eu-large-scale-pilots",
              "/docs/ecosystem-engagements/funded-programmes"
            ],
            "to": "/docs/ecosystem-engagements/eudi-wallet-pilots-and-deployments"
          },
          {
            "from": "/docs/api/config-update-digital-wallet-open-id-credential-history",
            "to": "/docs/openid4vc-api/config-update-digital-wallet-open-id-credential-history"
          },
          {
            "from": "/docs/api/config-create-digital-wallet-open-id-verification-request",
            "to": "/docs/openid4vc-api/config-create-digital-wallet-open-id-verification-request-v-3"
          },
          {
            "from": "/docs/openid4vc-api/config-delete-digital-wallet-open-id-file",
            "to": "/docs/extensions-api/config-delete-digital-wallet-open-id-file"
          },
          {
            "from": "/docs/openid4vc-api/config-list-digital-wallet-open-id-file",
            "to": "/docs/extensions-api/config-list-digital-wallet-open-id-file"
          },
          {
            "from": "/docs/openid4vc-api/config-read-digital-wallet-open-id-file",
            "to": "/docs/extensions-api/config-read-digital-wallet-open-id-file"
          },
          {
            "from": "/docs/extensions-api/get-post-oidc-auth",
            "to": "/docs/extensions-api/get-post-oidc-user-info"
          },
          {
            "from": "/docs/ts12-payment-confirmation/",
            "to": "/docs/ts12-payment-authorisation/"
          },
          {
            "from": [
              "/docs/ts12-emandate-authorization/",
              "/docs/ts12-recurring-payment-mandate/"
            ],
            "to": "/docs/ts12-emandate/"
          }
        ]
      }
    ],
    "/usr/src/app/src/plugins/docusaurus-plugin-structured-data-modified/index.js",
    "docusaurus-plugin-sass",
    "/usr/src/app/src/plugins/docusaurus-plugin-llms-txt.js",
    [
      "docusaurus-plugin-openapi-docs",
      {
        "id": "openapi",
        "docsPluginId": "classic",
        "config": {
          "api": {
            "specPath": "openapispecifications/consent-individual.yaml",
            "outputDir": "docs/consent-management-individual-api",
            "sidebarOptions": {
              "groupPathsBy": "tag",
              "categoryLinkSource": "auto"
            }
          },
          "oid4vcApi": {
            "specPath": "openapispecifications/oid4vc.yaml",
            "outputDir": "docs/openid4vc-api",
            "sidebarOptions": {
              "groupPathsBy": "tag",
              "categoryLinkSource": "auto"
            }
          },
          "consentAdminApi": {
            "specPath": "openapispecifications/consent-admin.yaml",
            "outputDir": "docs/consent-management-admin-api",
            "sidebarOptions": {
              "groupPathsBy": "tag",
              "categoryLinkSource": "auto"
            }
          },
          "extensionsApi": {
            "specPath": "openapispecifications/extensions.yaml",
            "outputDir": "docs/extensions-api",
            "sidebarOptions": {
              "groupPathsBy": "tag",
              "categoryLinkSource": "auto"
            }
          },
          "drvBundApi": {
            "specPath": "openapispecifications/drvbund.yaml",
            "outputDir": "docs/drv-bund-api",
            "sidebarOptions": {
              "groupPathsBy": "tag",
              "categoryLinkSource": "auto"
            }
          },
          "datamarketplaceApi": {
            "specPath": "openapispecifications/datamarketplace.yaml",
            "outputDir": "docs/datamarketplace-api",
            "sidebarOptions": {
              "groupPathsBy": "tag",
              "categoryLinkSource": "auto"
            }
          },
          "datamarketplaceIndividualApi": {
            "specPath": "openapispecifications/datamarketplace-individual.yaml",
            "outputDir": "docs/datamarketplace-individual-api",
            "sidebarOptions": {
              "groupPathsBy": "tag",
              "categoryLinkSource": "auto"
            }
          }
        }
      }
    ],
    [
      "@docusaurus/plugin-content-docs",
      {
        "id": "cDocs",
        "path": "cDocs",
        "editUrl": "https://github.com/L3-iGrant/docs.igrant.io/edit/master/",
        "routeBasePath": "concepts",
        "sidebarPath": "/usr/src/app/sidebars/sidebarsConcepts.js",
        "showLastUpdateAuthor": false,
        "showLastUpdateTime": true
      }
    ],
    [
      "@docusaurus/plugin-content-docs",
      {
        "id": "regDocs",
        "path": "regDocs",
        "editUrl": "https://github.com/L3-iGrant/docs.igrant.io/edit/master/",
        "routeBasePath": "regulations",
        "sidebarPath": "/usr/src/app/sidebars/sidebarsRegs.js",
        "showLastUpdateAuthor": false,
        "showLastUpdateTime": true
      }
    ],
    [
      "@docusaurus/plugin-content-docs",
      {
        "id": "dexaDocs",
        "path": "dexaDocs",
        "routeBasePath": "schema",
        "sidebarPath": "/usr/src/app/sidebars/sidebarsDA.js",
        "showLastUpdateAuthor": false,
        "showLastUpdateTime": true
      }
    ],
    [
      "/usr/src/app/docusaurus-plugin-gtm/index.js",
      {}
    ],
    [
      "@docusaurus/plugin-sitemap",
      {
        "id": "sitemap",
        "changefreq": "weekly",
        "priority": 0.5,
        "ignorePatterns": [
          "/tags/**"
        ],
        "filename": "sitemap.xml"
      }
    ]
  ],
  "markdown": {
    "mermaid": true
  },
  "themes": [
    "docusaurus-theme-openapi-docs",
    "@docusaurus/theme-mermaid",
    "docusaurus-theme-search-typesense"
  ],
  "clientModules": [
    "/usr/src/app/src/clientModules/docsearchKeydownGuard.js",
    "/usr/src/app/src/clientModules/docsearchDrawerHeader.js"
  ],
  "baseUrlIssueBanner": true,
  "i18n": {
    "defaultLocale": "en",
    "path": "i18n",
    "locales": [
      "en"
    ],
    "localeConfigs": {}
  },
  "onDuplicateRoutes": "warn",
  "staticDirectories": [
    "static"
  ],
  "customFields": {},
  "stylesheets": [],
  "titleDelimiter": "|",
  "noIndex": false
};
